// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS, HIDE_SCROLLBARS } from 'shared/styles/base';

export const Container = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.spacing60};
  border-bottom: 1px solid ${({ theme }) => theme.colors.textOutline};
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textPrimary};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyLarge};
  }
`;

export const TagsContainer = styled.div`
  ${HIDE_SCROLLBARS}
  width: 100vw;
  display: flex;
  overflow-x: auto;
  padding-left: ${({ theme }) => theme.spacing.spacing100};
  margin-left: ${({ theme }) => `-${theme.spacing.spacing100}`};
`;
